<template>
  <div class="fd">
    <div v-if="!isDialog" class="fd-header">
      <h3>正在编辑表单：{{ ext.title }}</h3>
      <div>
        <el-button type="primary" @click="doSave">保 存</el-button>
        <el-button @click="getExtFields">取 消</el-button>
      </div>
    </div>
    <div class="fd-content">
      <div class="fd-left">
        <h4 class="">表单控件</h4>
        <draggable
          class="fd-type"
          :list="types"
          :group="{ name: 'fields', pull: 'clone', put: false }"
          :sort="false"
          @end="end"
        >
          <template v-for="(type, index) in types">
            <div class="fd-type-item" :key="index" v-if="type.class == 'basic'">
              <icon-park :type="type.icon" theme="outline" size="14" fill="#999" :strokeWidth="4" />
              <span>{{ type.nameDisp }}</span>
            </div>
          </template>
        </draggable>

        <h4 class="c_m_t_n">展示控件</h4>
        <draggable
          class="fd-type"
          :list="types"
          :group="{ name: 'fields', pull: 'clone', put: false }"
          :sort="false"
          @end="end"
        >
          <template v-for="(type, index) in types">
            <div class="fd-type-item" :key="index" v-if="type.class == 'layout'">
              <icon-park :type="type.icon" theme="outline" size="14" fill="#999" :strokeWidth="4" />
              <span>{{ type.nameDisp }}</span>
            </div>
          </template>
        </draggable>
      </div>
      <div class="fd-center">
        <div class="c-flex c-flex-between">
          <h4>表单设计</h4>
          <div class="fd-center-icons">
            <icon-park
              type="workbench"
              :theme="preview == 'pc' ? 'multi-color' : 'outline'"
              size="18"
              :fill="['#333', '#409EFF', '#FFF', '#43CCF8']"
              :strokeWidth="3"
              :class="preview == 'pc' ? 'active c-m-r-15' : 'c-m-r-15'"
              @click.native="preview = 'pc'"
            />
            <icon-park
              type="phone"
              :theme="preview == 'mobile' ? 'multi-color' : 'outline'"
              size="18"
              :fill="['#333', '#409EFF', '#FFF', '#43CCF8']"
              :strokeWidth="3"
              :class="preview == 'mobile' ? 'active c-m-r-15' : 'c-m-r-15'"
              @click.native="preview = 'mobile'"
            />
          </div>
        </div>
        <div
          :class="preview == 'mobile' ? 'fd-center-detail mobile' : 'fd-center-detail'"
          :style="{
            flex: isDialog && fields.length > 0 ? 'none' : 1
          }"
        >
          <el-form ref="form" label-width="80px" label-position="top" :class="preview">
            <draggable :list="fields" group="fields">
              <div v-for="(f, index) in fields" :key="index" @click="fieldClick(f), getCfg(f)">
                <div :class="formData == f ? 'fd-form-item active' : 'fd-form-item'">
                  <el-form-item :class="'type-' + f.type">
                    <div
                      slot="label"
                      v-if="f.type != 'button' && f.type != 'map'"
                      class="c-flex c_item_center c-cursor-move"
                    >
                      <template v-if="!isDialog">
                        <template v-for="(type, i) in types">
                          <icon-park
                            :key="i"
                            v-if="type.type == f.type"
                            :type="type.icon"
                            theme="outline"
                            size="14"
                            fill="#999"
                            :strokeWidth="4"
                            class="c-m-r-5"
                          />
                        </template>
                      </template>
                      <div
                        v-if="
                          (f.type == 'title' || f.type == 'displayText' || f.type == 'gap') &&
                            $util.isJson(f.frontEndConfig) &&
                            JSON.parse(f.frontEndConfig).html
                        "
                        :class="f.type == 'title' ? 'c-font-bold' : ''"
                      >
                        <span v-html="JSON.parse(f.frontEndConfig).html"></span>
                      </div>
                      <span
                        v-else-if="f.type == 'gap' || f.type == 'button' || f.type == 'map'"
                      ></span>
                      <span v-else>
                        <span :class="f.type == 'title' ? 'c-font-bold' : ''">
                          {{ f.nameDisp }}
                        </span>
                        <span v-if="f.required == 1" class="c_red">
                          *
                        </span>
                      </span>
                    </div>
                    <!-- 地图弹窗 -->
                    <template v-if="f.type == 'map'">
                      <div style="display: flex;">
                        <el-input
                          disabled
                          :placeholder="f.placeholder"
                          class="map-selection-input"
                        ></el-input>
                        <el-button
                          type="primary"
                          icon="el-icon-position"
                          @click.native="initMap()"
                          style="border-radius: 0 4px 4px 0;height:32px;"
                        >
                          地图选址
                        </el-button>
                      </div>

                      <!-- <div :id="f.name" style="width: 100%;height: 300px;"></div> -->
                    </template>
                    <!-- 单行文本 数字 手机 -->
                    <el-input
                      v-if="
                        f.type == 'text' ||
                          f.type == 'number' ||
                          f.type == 'phone' ||
                          f.type == 'code'
                      "
                      :type="f.type"
                      :placeholder="f.placeholder"
                      disabled
                    ></el-input>
                    <!-- 多行文本 -->
                    <el-input
                      v-if="f.type == 'textarea'"
                      type="textarea"
                      :rows="(f.exts && f.exts.rows) || 2"
                      :placeholder="f.placeholder"
                      disabled
                    ></el-input>
                    <!-- 单选 -->
                    <el-radio-group v-if="f.type == 'radio'">
                      <el-radio :label="1">选项1</el-radio>
                      <el-radio :label="2">选项2</el-radio>
                      <el-radio :label="3">选项3</el-radio>
                    </el-radio-group>
                    <!-- 多选 -->
                    <template v-if="f.type == 'checkbox'">
                      <el-checkbox>选项1</el-checkbox>
                      <el-checkbox>选项2</el-checkbox>
                      <el-checkbox>选项3</el-checkbox>
                    </template>
                    <!-- 下拉选择器 -->
                    <el-select
                      v-if="f.type == 'select' || f.type == 'bizSelect'"
                      :placeholder="f.placeholder || '请选择'"
                      clearable
                    >
                      <el-option label="选项1" value="1"></el-option>
                      <el-option label="选项2" value="2"></el-option>
                      <el-option label="选项3" value="3"></el-option>
                    </el-select>
                    <!-- 级联选择器 -->
                    <el-cascader
                      v-if="f.type == 'cascade'"
                      :options="options[f.valueOption]"
                      :placeholder="f.placeholder || '请选择'"
                    ></el-cascader>
                    <!-- 日期时间 -->
                    <el-date-picker
                      v-if="f.type == 'datetime'"
                      type="datetime"
                      :placeholder="f.placeholder || '选择日期时间'"
                    ></el-date-picker>
                    <!-- 日期 -->
                    <el-date-picker
                      v-if="f.type == 'date'"
                      type="date"
                      :placeholder="f.placeholder || '选择日期'"
                    ></el-date-picker>
                    <!-- 日期范围 -->
                    <el-date-picker
                      v-if="f.type == 'daterange'"
                      type="daterange"
                      :placeholder="f.placeholder || '选择日期范围'"
                    ></el-date-picker>
                    <!-- 时间 -->
                    <el-time-select v-if="f.type == 'time'" placeholder="选择时间"></el-time-select>
                    <!-- 时间范围 -->
                    <el-date-picker
                      v-if="f.type == 'datetimerange'"
                      type="datetimerange"
                      placeholder="选择时间范围"
                    ></el-date-picker>
                    <!-- 开关 -->
                    <el-switch v-if="f.type == 'switch'"></el-switch>
                    <!-- 评分 -->
                    <el-rate v-if="f.type == 'rate'"></el-rate>
                    <!-- 上传 -->
                    <el-upload v-if="f.type == 'file'" :show-file-list="false" action="">
                      <el-button icon="el-icon-upload" round>
                        点击上传文件
                      </el-button>
                    </el-upload>
                    <!-- 省市区 -->
                    <template v-if="f.type == 'area'">
                      <el-cascader
                        :placeholder="f.placeholder || '请选择'"
                        :popper-class="
                          f.frontEndConfig && f.frontEndConfig.cascaderLabelHide
                            ? 'cascaderLabelHide-wrapper'
                            : ''
                        "
                        ref="area"
                        :options="options.area"
                        :props="{
                          emitPath: f.frontEndConfig.emitPath == false ? false : true,
                          multiple: f.frontEndConfig.multiple || f.multiple ? true : false,
                          label: f.frontEndConfig.label ? f.frontEndConfig.label : 'label',
                          expandTrigger: f.frontEndConfig.propsExpandTrigger
                            ? f.frontEndConfig.propsExpandTrigger
                            : 'click',
                          checkStrictly: f.frontEndConfig.propsCheckStrictly
                            ? f.frontEndConfig.propsCheckStrictly
                            : false
                        }"
                      ></el-cascader>
                    </template>
                    <!-- 富文本 -->
                    <c-editor v-if="f.type == 'richText'" :formData="{}" value=""></c-editor>
                    <!-- 超链接 -->
                    <a v-if="f.type == 'aLink'" href=""></a>
                    <el-button v-if="f.type == 'button'" style="width:100%">
                      {{ f.nameDisp }}
                    </el-button>
                  </el-form-item>
                  <div class="fd-form-item-icons">
                    <icon-park
                      class="copy"
                      type="copy"
                      theme="outline"
                      size="14"
                      :strokeWidth="4"
                      @click.native="fieldCopy(f, index)"
                    />
                    <p></p>
                    <icon-park
                      class="delete"
                      type="delete"
                      theme="outline"
                      size="14"
                      :strokeWidth="4"
                      @click.native="fieldDelete(f, index)"
                    />
                  </div>
                </div>
              </div>
            </draggable>
          </el-form>
        </div>
      </div>
      <div class="fd-right">
        <div class="c-flex c-flex-between c_p_b_n">
          <h4>字段配置</h4>
          <template v-for="(type, i) in types">
            <p
              class="c-flex c_item_center c_size_14 c_info"
              :key="i"
              v-if="type.type == formData.type"
            >
              <icon-park
                :type="type.icon"
                theme="outline"
                size="14"
                fill="#999"
                :strokeWidth="4"
                class="c-m-r-5"
              />
              <span>{{ type.nameDisp }}</span>
            </p>
          </template>
        </div>
        <el-form
          :model="formData"
          :rules="$util.rules"
          ref="formData"
          label-width="80px"
          label-position="top"
        >
          <el-form-item
            label="显示名称"
            prop="nameDisp"
            :rules="{
              required: 'true',
              trigger: 'change',
              message: '请输入显示名称'
            }"
          >
            <el-input v-model="formData.nameDisp"></el-input>
          </el-form-item>
          <el-form-item label="属性名" prop="name" v-if="user._id == user.tenantId">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type" v-if="user._id == user.tenantId">
            <el-select v-model="formData.type" @change="formData.valueOption = ''">
              <el-option
                v-for="item in options.fieldType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.value }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-button
            v-if="formData.type == 'bizSelect'"
            type="primary"
            size="small"
            @click="referenceOpen(formData)"
          >
            关联档案配置
          </el-button>
          <el-form-item
            label="关联代码"
            v-if="
              formData.type == 'radio' ||
                formData.type == 'checkbox' ||
                formData.type == 'select' ||
                formData.type == 'cascade' ||
                formData.type == 'addItem' ||
                formData.type == 'request' ||
                formData.type == 'bizSelect'
            "
            :rules="{
              required: formData.type == 'bizSelect' ? true : false,
              trigger: 'change',
              message: '请选择关联代码'
            }"
          >
            <el-select
              filterable
              clearable
              allow-create
              default-first-option
              placeholder="可输入名称搜索"
              v-model="formData.valueOption"
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.codeType"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.type }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否多选"
            prop="multiple"
            v-if="
              formData.type == 'select' ||
                formData.type == 'bizSelect' ||
                formData.type == 'cascade' ||
                formData.type == 'request' ||
                formData.type == 'area'
            "
            :rules="{
              required: 'true',
              trigger: 'change',
              message: '请选择是否多选'
            }"
          >
            <div style="display:flex">
              <el-radio v-model="formData.multiple" :label="false">单选</el-radio>
              <el-radio v-model="formData.multiple" :label="true">多选</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="计算公式" v-if="formData.type == 'evaluate'">
            <el-select
              filterable
              allow-create
              v-model="formData.frontEndConfig.evaluate"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.scripts"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label-width="96px"
            label="报单背景图片(900×565)"
            v-if="formData.type == 'bgImage'"
          >
            <el-upload
              class="c-uploader"
              :action="upload.url"
              :data="upload.data"
              :show-file-list="false"
              :on-exceed="osg.uploadExceed"
              :before-upload="
                file => {
                  return osg.beforeUpload(file, 'image');
                }
              "
              :on-success="onUploadsuccess"
              :on-error="osg.uploadError"
              :before-remove="
                (file, fileList) => {
                  return beforeRemove(file, fileList, 'fileList');
                }
              "
              :on-remove="
                (file, fileList) => {
                  return onRemove(file, fileList, 'fileList');
                }
              "
            >
              <img
                v-if="formData.frontEndConfig"
                :src="JSON.parse(formData.frontEndConfig).list[0]"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="preset"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择是否预置'
            }"
          >
            <div slot="label">
              <span>字段存储</span>
              <el-tooltip
                effect="dark"
                content="租户扩展将字段值存在数据对象的exts对象"
                placement="top"
              >
                <i class="el-icon-question c_info c-m-l-5"></i>
              </el-tooltip>
            </div>
            <div style="display:flex">
              <el-radio v-model="formData.preset" :label="1">系统预置</el-radio>
              <el-radio v-model="formData.preset" :label="0">租户扩展</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="字段校验" prop="required">
            <div style="display:flex">
              <el-checkbox v-model="formData.required" true-label="1" false-label="0">
                必填
              </el-checkbox>
            </div>
          </el-form-item>
          <el-form-item
            label="操作权限"
            prop="operationType"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择操作权限'
            }"
          >
            <el-select v-model="formData.operationType">
              <el-option
                v-for="item in options.operationType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="查看权限"
            prop="showType"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择是否展示'
            }"
          >
            <el-select
              v-model="formData.showType"
              @change="
                formData.showField = '';
                formData.showValue = '';
              "
            >
              <el-option
                v-for="item in options.showType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="当字段"
            prop="showField"
            v-if="formData.showType == '3'"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '请输入'
            }"
          >
            <el-select
              filterable
              allow-create
              default-first-option
              placeholder="可输入名称搜索"
              v-model="formData.showField"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in fields"
                :key="item.name"
                :label="item.nameDisp"
                :value="item.name"
                @click.native="getOptions(item, formData.showField), $forceUpdate()"
              >
                <span style="float: left">{{ item.nameDisp }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.name }}
                </span>
              </el-option>
            </el-select>
            <!-- <el-input v-model="formData.showField" placeholder="根据此字段的值展示"></el-input> -->
          </el-form-item>
          <el-form-item
            label="等于*时"
            prop="showValue"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '请输入'
            }"
            v-if="formData.showType == '3'"
          >
            <el-cascader
              v-if="showField.type == 'cascade'"
              v-model="formData.exts.showValue"
              placeholder="请选择"
              :options="osArr"
              clearable
              :props="{
                label: 'name',
                multiple: true
              }"
            ></el-cascader>
            <el-select
              v-else-if="this.osArr != ''"
              filterable
              allow-create
              default-first-option
              placeholder="可输入名称搜索"
              v-model="formData.showValue"
              @change="$forceUpdate()"
              clearable
            >
              <el-option
                v-for="item in this.osArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <!-- <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.type }}
                </span> -->
              </el-option>
            </el-select>
            <el-input
              v-else-if="this.osArr == ''"
              v-model="formData.showValue"
              placeholder="当字段值等于此值时展示"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="角色"
            prop="roleIds"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
            v-if="formData.showType == '4' || formData.showType == '5'"
          >
            <el-select multiple clearable v-model="formData.roleIds" @change="$forceUpdate()">
              <el-option
                v-for="item in options.roles"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="渗漏原因"
            prop="showList"
            v-if="ext.colName == 'survey' && formData.type == 'file'"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              v-model="formData.exts.leakageCause"
              placeholder="上传图片会将此段内容自动填入渗漏原因"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="展示位置"
            prop="showList"
            :rules="{
              required: false,
              type: 'array',
              trigger: 'change',
              message: '请选择展示位置'
            }"
          >
            <el-checkbox-group v-model="formData.showList">
              <el-checkbox :label="item.value" v-for="(item, i) in options.showList" :key="i">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item prop="listEditable" v-if="formData.showList.indexOf('1') != -1">
            <div slot="label">
              <span>是否允许在列表编辑</span>
            </div>
            <div style="display:flex">
              <el-radio v-model="formData.exts.listEditable" :label="true">允许</el-radio>
              <el-radio v-model="formData.exts.listEditable" :label="false">不允许</el-radio>
            </div>
          </el-form-item>
          <el-form-item v-if="formData.exts" prop="replicable">
            <div slot="label">
              <span>是否允许点击复制</span>
            </div>
            <div style="display:flex">
              <el-radio v-model="formData.exts.replicable" :label="true">允许</el-radio>
              <el-radio v-model="formData.exts.replicable" :label="false">不允许</el-radio>
            </div>
          </el-form-item>
          <el-form-item
            label="字段列宽"
            v-if="formData.showList && formData.showList.indexOf('1') != -1"
          >
            <el-input
              v-model="formData.width"
              placeholder="字段列在pc列表的宽度，例如：100px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="列是否固定"
            v-if="formData.showList && formData.showList.indexOf('1') != -1"
          >
            <el-select v-model="formData.fixed">
              <el-option label="不固定" value=""></el-option>
              <el-option label="固定在列表左侧" value="left"></el-option>
              <el-option label="固定在列表右侧" value="right"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="详情页跳转"
            v-if="formData.showList && formData.showList.indexOf('1') != -1"
          >
            <el-input
              type="textarea"
              v-model="formData.router"
              placeholder="如需点击字段值跳转到详情页，请填路由地址，例如：ServiceAppointment"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="打开新的标签名称"
            v-if="formData.showList && formData.showList.indexOf('1') != -1"
          >
            <el-input
              type="textarea"
              v-model="formData.exts.routerName"
              placeholder="请输入标签页的名称(例如:工单详情等)"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="路由匹配的名称"
            v-if="formData.showList && formData.showList.indexOf('1') != -1"
          >
            <el-input
              type="textarea"
              v-model="formData.exts.routeTitle"
              placeholder="为路由配置名称，确保符合匹配规则"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="提示文字"
            v-if="formData.showList && formData.showList.indexOf('2') != -1"
          >
            <el-input v-model="formData.placeholder" placeholder="占位符"></el-input>
          </el-form-item>
          <el-form-item label="json配置" v-if="user._id == user.tenantId">
            <el-input
              v-model="formData.frontEndConfig"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-divider>脚本配置</el-divider>
          <el-form-item label="触发方式">
            <el-select
              filterable
              allow-create
              v-model="formData.calculateConfig.trigger"
              clearable
              @change="
                formData.calculateConfig.triggerName = null;
                $forceUpdate();
              "
            >
              <el-option
                v-for="item in options.triggerMode"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="输入框按钮名称"
            v-if="formData.calculateConfig.trigger == 'appendButton'"
          >
            <el-input
              v-model="formData.calculateConfig.triggerName"
              :placeholder="`默认为“点击执行”`"
            ></el-input>
          </el-form-item>
          <el-form-item label="前端执行脚本">
            <el-select
              filterable
              allow-create
              v-model="formData.calculateConfig.scriptId"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.scripts"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="后端执行脚本">
            <el-select
              filterable
              allow-create
              v-model="formData.calculateConfig.groovyScriptId"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in options.scripts"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-divider>导入配置</el-divider>
          <el-form-item
            label="是否支持导入"
            prop="importFlag"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <div style="display:flex">
              <el-radio v-model="formData.importFlag" :label="1" @change="importFlagChange">
                支持导入
              </el-radio>
              <el-radio v-model="formData.importFlag" :label="0" @change="importFlagChange">
                不支持导入
              </el-radio>
            </div>
          </el-form-item>
          <el-form-item
            v-if="formData.importFlag == 1"
            label="是否必须导入本字段"
            prop="importRequired"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <div style="display:flex">
              <el-radio v-model="formData.importRequired" :label="1">
                必须导入(不能为空)
              </el-radio>
              <el-radio v-model="formData.importRequired" :label="0">不必须导入</el-radio>
            </div>
          </el-form-item>
          <el-form-item
            v-if="formData.importFlag == 1"
            label="新增导入本字段是否判重"
            prop="importDistinct"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <div style="display:flex">
              <el-radio v-model="formData.importDistinct" :label="1">
                新增需要判重
              </el-radio>
              <el-radio v-model="formData.importDistinct" :label="0">不需要判重</el-radio>
            </div>
          </el-form-item>
          <el-form-item
            label="同步时是否作为唯一判断标识"
            prop="importSync"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <div style="display:flex">
              <el-radio v-model="formData.importSync" :label="1">是唯一判断标识</el-radio>
              <el-radio v-model="formData.importSync" :label="0">非唯一判断标识</el-radio>
            </div>
          </el-form-item>
          <el-form-item
            v-if="formData.importFlag == 1"
            label="表头名称"
            prop="importName"
            :rules="{
              required: true,
              trigger: 'change',
              message: '默认等于字段显示名称'
            }"
          >
            <el-input v-model="formData.importName"></el-input>
          </el-form-item>
          <el-form-item
            v-if="formData.importFlag == 1"
            label="导入数据转化类型"
            prop="importType"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <el-select v-model="formData.importType">
              <el-option
                v-for="item in options.importType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-dialog class="bizSelect-dialog" title="关联业务档案配置" :visible.sync="reference.show">
          <el-form
            :model="reference.fec"
            label-width="100px"
            label-position="left"
            v-if="reference.show"
          >
            <el-form-item label="查询单据">
              <el-select
                v-model="reference.colName"
                filterable
                clearable
                placeholder="请选择要查询的单价"
              >
                <el-option
                  v-for="item in options.exts"
                  :key="item.colName"
                  :label="item.title"
                  :value="item.colName"
                  @click.native="referenceColNameClick(item)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-divider content-position="left">请求参数</el-divider>
            <el-form-item label="查询条数">
              <el-radio-group
                v-model="reference.pagination"
                @change="
                  val => {
                    if (val == '1') {
                      $set(reference.fec, '_all', '1');
                      delete reference.fec.page;
                      delete reference.fec.rows;
                    } else if (val == '2') {
                      $set(reference.fec, 'page', '1');
                      $set(reference.fec, 'rows', '20');
                      delete reference.fec._all;
                    }
                    $forceUpdate();
                  }
                "
              >
                <el-radio label="1">全部</el-radio>
                <el-radio label="2">分页查询</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="reference.pagination == '2'">
              <span>
                默认查询第
                <el-input
                  v-model="reference.fec.page"
                  sizi="mini"
                  class="pagination-input"
                ></el-input>
                页，每页查询
                <el-input
                  v-model="reference.fec.rows"
                  sizi="mini"
                  class="pagination-input"
                ></el-input>
                条
              </span>
            </el-form-item>
            <el-form-item label="返回值排序">
              <el-select v-model="reference.fec.sortField" filterable clearable>
                <el-option
                  :label="item.nameDisp"
                  :value="item.name"
                  v-for="(item, i) in reference.fields"
                  :key="i"
                ></el-option>
              </el-select>
              <el-select
                v-model="reference.fec.sortOrder"
                clearable
                class="c-m-l-10"
                style="width:100px !important"
              >
                <el-option label="正序" value="asc">正序</el-option>
                <el-option label="倒叙" value="desc">倒叙</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="过滤条件">
              <div style="height:auto;display:flex;flex-direction:column">
                <el-table style="width:100% !important" :data="reference.params">
                  <el-table-column label="字段">
                    <template slot-scope="{ row }">
                      <el-select v-model="row.fieldName" filterable clearable allow-create>
                        <el-option
                          v-for="item in reference.fields"
                          :key="item.name"
                          :label="item.nameDisp"
                          :value="item.name"
                          @click.native="row.targetField = item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="条件">
                    <template slot-scope="{ row }">
                      <el-select v-model="row.condition" filterable clearable allow-create>
                        <el-option
                          v-for="item in options.condition"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="值类型">
                    <template slot-scope="{ row }">
                      <el-select
                        v-if="row.condition != 'doesNotExists' && row.condition != 'exists'"
                        v-model="row.valueType"
                        filterable
                        clearable
                        allow-create
                        @change="
                          row.value = '';
                          row.values = [];
                        "
                      >
                        <el-option label="固定值" :value="1"></el-option>
                        <el-option
                          label="模糊查询输入框的值"
                          :value="2"
                          @click.native="row.value = '#query'"
                        ></el-option>
                        <el-option label="查询表单字段的选项" :value="3"></el-option>
                        <el-option label="当前表单的字段值" :value="4"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot="header">
                      <div>
                        值
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content">
                            当条件为“包含”、值选择了多个时，表示满足任意一个值即可。
                            <br />
                          </div>
                          <i class="el-icon-info c_blue"></i>
                        </el-tooltip>
                      </div>
                    </template>
                    <template
                      v-if="row.condition != 'doesNotExists' && row.condition != 'exists'"
                      slot-scope="{ row }"
                    >
                      <template v-if="!row.valueType || row.valueType == '1'">
                        <el-date-picker
                          v-if="
                            row.targetField.type == 'datetime' || row.targetField.type == 'date'
                          "
                          :type="row.targetField.type"
                          v-model="row.value"
                        ></el-date-picker>
                        <el-input
                          v-else
                          v-model="row.value"
                          :type="
                            row.targetField.type == 'number' || row.targetField.type == 'digit'
                              ? 'number'
                              : 'text'
                          "
                        ></el-input>
                      </template>
                      <span v-else-if="row.valueType == '2'">模糊查询输入框的值</span>
                      <el-select
                        v-else-if="row.valueType == '3'"
                        v-model="row.values"
                        filterable
                        clearable
                        allow-create
                        multiple
                      >
                        <el-option
                          v-for="item in reference.options[row.fieldName] || []"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-else-if="row.valueType == '4'"
                        v-model="row.value"
                        filterable
                        clearable
                        allow-create
                      >
                        <el-option
                          v-for="item in fields"
                          :key="item.name"
                          :label="item.nameDisp"
                          :value="item.name"
                          @click.native="row.field = item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot="header">
                      <div>
                        和其他条件的关联
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content">
                            1~多个“且”：同时满足所有条件
                            <br />
                            1~多个“或”：至少满足一个条件
                            <br />
                            “且”和“或”同时存在：同时满足所有是“且”的条件，并且至少满足一个是“或”的条件
                          </div>
                          <i class="el-icon-info c_blue"></i>
                        </el-tooltip>
                      </div>
                    </template>
                    <template slot-scope="{ row }">
                      <el-select v-model="row.relation" clearable>
                        <el-option label="或" value="or"></el-option>
                        <el-option label="且" value="and"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column width="60px">
                    <template slot-scope="{ $index }">
                      <el-button
                        plain
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="reference.params.splice($index, 1)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  style="align-self: flex-start;margin-top: 10px;"
                  type="text"
                  @click="
                    reference.params.push({
                      fieldName: '',
                      targetField: {},
                      condition: '',
                      valueType: '',
                      value: '',
                      values: [],
                      field: {},
                      relation: ''
                    })
                  "
                >
                  添加过滤条件
                </el-button>
              </div>
            </el-form-item>
            <el-divider content-position="left">
              返回值设置
              <el-tooltip
                effect="dark"
                content="解析返回值并将其赋值给当前表单字段"
                placement="top"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-divider>
            <el-form-item label="赋值规则">
              <div style="height:auto;display:flex;flex-direction:column">
                <el-table :data="reference.setValue">
                  <el-table-column label="当前表单字段值" width="200px">
                    <template slot-scope="{ row }">
                      <el-select v-model="row.key" filterable clearable allow-create>
                        <el-option
                          v-for="item in fields"
                          :key="item.name"
                          :label="item.nameDisp"
                          :value="item.name"
                          @click.native="row.field = item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column width="30px">
                    <span class="f-w-b">=</span>
                  </el-table-column>
                  <el-table-column label="返回表单字段值" width="200px">
                    <template slot-scope="{ row }">
                      <el-select v-model="row.value" filterable clearable allow-create>
                        <el-option
                          v-for="item in reference.fields"
                          :key="item.name"
                          :label="item.nameDisp"
                          :value="item.name"
                          @click.native="row.targetField = item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column width="60px">
                    <template slot-scope="{ $index }">
                      <el-button
                        plain
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="reference.setValue.splice($index, 1)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  style="align-self: flex-start;margin-top: 10px;"
                  type="text"
                  @click="
                    reference.setValue.push({
                      key: '',
                      field: {},
                      value: '',
                      targetField: {}
                    })
                  "
                >
                  添加赋值规则
                </el-button>
              </div>
            </el-form-item>
            <el-divider content-position="left">其他配置</el-divider>
            <el-form-item label="取表单哪个字段值用来显示" label-width="220px">
              <el-select v-model="reference.fec.label" filterable clearable>
                <el-option
                  v-for="(item, i) in reference.fields"
                  :key="i"
                  :label="item.nameDisp"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="取表单哪个字段值用来存储" label-width="220px">
              <el-select v-model="reference.fec.value" filterable clearable>
                <el-option key="_id" label="ID" value="_id"></el-option>
                <el-option
                  v-for="(item, i) in reference.fields"
                  :key="i"
                  :label="item.nameDisp"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否允许模糊搜索" label-width="220px">
              <el-switch
                v-model="reference.fec.filterable"
                active-text="允许"
                inactive-text="不允许"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许实时查询" label-width="220px">
              <el-switch
                v-model="reference.fec.remote"
                active-text="允许"
                inactive-text="不允许"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
            <el-form-item label="输入框获取焦点时是否触发查询" label-width="220px">
              <el-switch
                v-model="reference.fec.focus"
                active-text="允许"
                inactive-text="不允许"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer c-flex c-flex-between">
            <el-popover placement="top-start" width="500" trigger="click">
              {
              <div style="margin-left:15px;">
                <template v-for="(value, key, index) in reference.fec">
                  <div v-if="key == 'params' || key == 'setValue'" :key="index">
                    <div>
                      <span style="display:inline-block;width:60px">{{ key }}:</span>
                      <span>{</span>
                    </div>
                    <div
                      v-for="(subValue, subKey, subIndex) in value"
                      :key="subIndex"
                      style="margin-left:75px"
                    >
                      <span>{{ subKey }}: {{ subValue }}</span>
                      <span v-if="subIndex != Object.keys(value).length - 1">,</span>
                    </div>
                    <div style="margin-left:60px">
                      }
                      <span v-if="index != Object.keys(reference.fec).length - 1">,</span>
                    </div>
                  </div>
                  <div v-else :key="index">
                    <span>{{ key }}: {{ value }}</span>
                    <span v-if="index != Object.keys(reference.fec).length - 1">,</span>
                  </div>
                </template>
              </div>
              }

              <el-button slot="reference" @click="setReference('preview')">编码预览</el-button>
            </el-popover>
            <div>
              <el-button @click="reference.show = false">取 消</el-button>

              <el-button type="primary" @click="setReference">确 定</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-dialog
      width="1000px"
      title="选择地址"
      :visible.sync="record.openMap"
      @close="record.openMap = false"
      modal
    >
      <div style="width: 100%;height: 800px;display: flex;flex-direction: column;">
        <el-form label-width="120px">
          <el-form-item label="请输入详细地址">
            <el-input disabled></el-input>
          </el-form-item>
        </el-form>
        <div id="container" style="width: 100%;flex: 1;"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="record.openMap = false">取 消</el-button>
        <el-button type="primary" @click="record.openMap = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'; //引入地图
import { isDict } from 'core-js/core/dict';

export default {
  activated() {
    window.$this = this;
  },
  props: {
    // 接收初始字段列表
    fields: {
      type: Array,
      default: () => []
    },
    // 是否作为弹窗组件使用
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    window.$this = this;
    return {
      localFields: [],
      extId: '',
      ext: {},
      // 当前登录用户
      user: {},
      // 左侧可选择组件
      types: [
        { nameDisp: '单行文本', type: 'text', icon: 'text', class: 'basic' },
        { nameDisp: '多行文本', type: 'textarea', icon: 'textarea', class: 'basic' },
        { nameDisp: '数字', type: 'number', icon: 'list-numbers', class: 'basic' },
        { nameDisp: '手机号', type: 'phone', icon: 'phone', class: 'basic' },
        { nameDisp: '单选', type: 'radio', icon: 'radio-two', class: 'basic' },
        { nameDisp: '多选', type: 'checkbox', icon: 'check-correct', class: 'basic' },
        { nameDisp: '下拉选择器', type: 'select', icon: 'drop-down-list', class: 'basic' },
        { nameDisp: '业务档案', type: 'bizSelect', icon: 'find', class: 'basic' },
        { nameDisp: '级联选择器', type: 'cascade', icon: 'list-checkbox', class: 'basic' },
        { nameDisp: '日期时间', type: 'datetime', icon: 'calendar-dot', class: 'basic' },
        { nameDisp: '日期', type: 'date', icon: 'calendar-thirty-two', class: 'basic' },
        { nameDisp: '日期范围', type: 'daterange', icon: 'calendar-thirty-two', class: 'basic' },
        { nameDisp: '时间', type: 'time', icon: 'time', class: 'basic' },
        { nameDisp: '时间范围', type: 'datetimerange', icon: 'time', class: 'basic' },
        { nameDisp: '开关', type: 'switch', icon: 'switch-button', class: 'basic' },
        { nameDisp: '评分', type: 'rate', icon: 'star', class: 'basic' },
        { nameDisp: '图片或文件', type: 'file', icon: 'upload', class: 'basic' },
        { nameDisp: '省市区', type: 'area', icon: 'map-draw', class: 'basic' },
        { nameDisp: '富文本', type: 'richText', icon: 'doc-detail', class: 'basic' },
        { nameDisp: '超链接', type: 'aLink', icon: 'link', class: 'basic' },
        { nameDisp: '代码', type: 'code', icon: 'code', class: 'basic' },
        { nameDisp: '地图', type: 'map', icon: 'map-draw', class: 'basic' },
        { nameDisp: '按钮', type: 'button', icon: 'link-four', class: 'basic' },
        { nameDisp: '标题', type: 'title', icon: 'h1', class: 'layout' },
        { nameDisp: '文字', type: 'displayText', icon: 'text-message', class: 'layout' },
        { nameDisp: '分隔槽', type: 'gap', icon: 'dividing-line', class: 'layout' }
      ],
      osArr: [], //字典表值
      preview: 'pc', // 预览模式
      formData: {
        required: '0',
        showField: '',
        showValue: '',
        showList: [],
        roleIds: [],
        calculateConfig: {}
      },
      options: {
        area: this.osg.areaList,
        codecfg_fieldType: { codeId: 'FIELD_TYPE' },
        operationType: [
          { label: '可编辑', value: '1' },
          { label: '只读', value: '2' },
          { label: '只读但允许创建', value: '3' }
        ],
        showType: [
          { label: '始终展示', value: '1' },
          { label: '有值才展示', value: '2' },
          { label: '根据其他字段展示', value: '3' },
          { label: '指定角色可见', value: '4' },
          { label: '指定角色不可见', value: '5' }
        ],
        showList: [
          { label: 'pc列表', value: '1' },
          { label: 'pc表单', value: '2' },
          { label: 'pc过滤器', value: '5' },
          { label: '参照弹窗过滤', value: '10' },
          { label: '属性变更记录', value: '6' },
          { label: '小程序列表', value: '3' },
          { label: '小程序表单', value: '4' },
          { label: '小程序过滤器', value: '7' },
          { label: '小程序批量派单', value: '8' },
          { label: '呼叫弹窗', value: '9' },
          { label: '客服工作台过滤', value: '11' },
          { label: '关联业务档案', value: '12' }
        ],
        is: [{ label: '是', value: '1' }, { label: '否', value: '2' }],
        codecfg_importType: { codeId: 'importType' },
        triggerMode: [
          { label: '输入或选择', value: 'change' },
          { label: '输入框按钮', value: 'appendButton' }
        ],
        exts: [],
        codecfg_condition: { codeId: 'condition' }
      },
      selectValue: '', //防止el-select组件不绑定v-model警告
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      },
      // 参照业务档案
      reference: {
        show: false,
        colName: '',
        fields: [],
        options: [],
        params: [],
        pagination: '',
        fec: {},
        setValue: []
      },
      // 根据其他字段展示
      showField: {},
      record: { openMap: false }
    };
  },
  watch: {
    // 监听外部传入的字段变化
    // fields: {
    //   handler(newFields) {
    //     this.localFields = JSON.parse(JSON.stringify(newFields));
    //   },
    //   immediate: true
    // }
  },
  created() {
    // 如果不是弹窗模式,则获取字段配置
    if (!this.isDialog) {
      this.getExtFields();
    }
  },
  mounted() {
    this.user = sessionStorage['loginAccount'] || {};
    this.osg.codeoption(() => {
      this.$forceUpdate();
    });
    if (!this.isDialog) {
      this.getExt();
      this.getExtFields();
    }
    this.getCodeTypes();
    this.getScripts();
    // window.addEventListener('beforeunload', () => {
    //   return '';
    // });
    window.onbeforeunload = () => {
      return '';
    };
    this.getExts(); //查询所有表单，配置关联业务档案时使用
    this.getRoles();
  },
  methods: {
    //获取字典表
    getOptions(e, valueOption) {
      this.formData.showFieldPreset = e.preset;
      this.showField = e;
      console.log('this.showField', this.showField);
      if (
        valueOption != 'area' &&
        valueOption != 'serviceTerritory' &&
        valueOption != 'workType' &&
        valueOption != 'channel'
      ) {
        this.osArr = [];
        if (e.type == 'cascade') {
          this.options['cascadeCode_' + e.valueOption] = { codeId: e.valueOption };
        } else {
          this.options['codecfg_' + e.valueOption] = { codeId: e.valueOption };
        }
        this.codeoption();
      }
    },
    // 反显等于*时的字段
    getCfg(f) {
      if (typeof f.showField == 'undefined' || f.showField == '') {
        return;
      } else {
        for (var i = 0, len = this.fields; i < len.length; i++) {
          if (len[i].name == f.showField) {
            // let valOption = len[i].valueOption;
            let e = len[i];
            this.getOptions(e, f.showField);
          }
        }
      }
    },
    // 字典表
    async codeoption(callback, that, optsName, tenantId) {
      if (window.navData) {
        let actionRole = window.navData.actionRole || {};
        var dataAuth = actionRole.dataAuth;
      }
      that = that || window.$this;
      let opts = {};
      if (optsName) {
        opts = that[optsName];
      } else {
        opts = that.options;
      }
      if (opts) {
        var cfgArr = [];
        var cascadeTypes = []; //级联的代码类型
        let codeAuthObj = {}; // 汇总有数据权限的字典
        for (var o in opts) {
          if (o.startsWith('codecfg_')) {
            let cfg = opts[o];
            cfg['eleid'] = o.substring(8);

            // 汇总有数据权限的字典
            if (cfg.frontEndConfig && cfg.frontEndConfig.codeAuth) {
              codeAuthObj[o.substring(8)] = cfg.frontEndConfig.codeAuth;
            }
            delete cfg.frontEndConfig;

            cfgArr.push(cfg);
            delete opts[o];
          }
          //组合级联代码类型
          if (o.startsWith('cascadeCode_')) {
            let cfg = opts[o];
            let type = o.substring(12);

            // 汇总有数据权限的字典
            if (cfg.frontEndConfig && cfg.frontEndConfig.codeAuth) {
              codeAuthObj[o.substring(12)] = cfg.frontEndConfig.codeAuth;
            }
            delete cfg.frontEndConfig;

            cascadeTypes.push(type);
            delete opts[o];
          }
        }
        await new Promise(resolve => {
          if (cfgArr.length > 0) {
            let params = JSON.stringify(cfgArr);
            this.osg.ajax(
              'i/code/selectCode.do',
              {
                jsonPara: params,
                tenantId: tenantId || null
              },
              res => {
                if (res) {
                  res = JSON.parse(res);
                  for (var i = 0; i < res.length; i++) {
                    var opts = res[i],
                      os = opts.options;
                    // var osArr = [];
                    // 有数据权限的字典
                    if (codeAuthObj[opts.eleid]) {
                      let codeAuth = codeAuthObj[opts.eleid];
                      if (codeAuth.dataAuth && codeAuth.dataAuth.indexOf(dataAuth) != -1) {
                        // 限制当前数据权限的
                        for (var opt in os) {
                          if (codeAuth.contains && codeAuth.contains.length > 0) {
                            if (codeAuth.contains.indexOf(opt) != -1) {
                              this.osArr.push({
                                label: os[opt],
                                value: opt
                              });
                            }
                          } else if (
                            codeAuth.doesNotContain &&
                            codeAuth.doesNotContain.length > 0
                          ) {
                            if (codeAuth.doesNotContain.indexOf(opt) == -1) {
                              this.osArr.push({
                                label: os[opt],
                                value: opt
                              });
                            }
                          }
                        }
                      } else {
                        for (let opt in os) {
                          this.osArr.push({
                            label: os[opt],
                            value: opt
                          });
                        }
                      }
                    } else {
                      for (let opt in os) {
                        this.osArr.push({
                          label: os[opt],
                          value: opt
                        });
                      }
                    }
                    if (optsName) {
                      that[optsName][opts.eleid] = this.osArr;
                      if (that.$refs.form && that.$refs.form.$refs.table) {
                        window.$this.refresh();
                      }
                    } else {
                      that.options[opts.eleid] = this.osArr;
                    }
                    // console.log(this.osArr, '------------this.osArr');
                  }
                  resolve();
                }
              },
              {
                noload: true
              }
            );
          } else {
            resolve();
          }
        });
        await new Promise(resolve => {
          //查询级联代码表数据
          if (cascadeTypes.length > 0) {
            this.osg.ajax(
              'i/code/selectMultistageCode.do',
              {
                types: cascadeTypes.join(),
                tenantId: tenantId || JSON.parse(sessionStorage['entity']).tenantId
              },
              res => {
                if (res.constructor == Array) {
                  res.map(item => {
                    if (codeAuthObj[item.type]) {
                      // 有数据权限的字典
                      let codeAuth = codeAuthObj[item.type];
                      if (codeAuth.dataAuth && codeAuth.dataAuth.indexOf(dataAuth) != -1) {
                        // 限制当前数据权限的
                        if (codeAuth.contains && codeAuth.contains.length > 0) {
                          item.children.map(obj => {
                            if (codeAuth.contains.indexOf(obj.value) == -1) {
                              obj.disabled = true;
                            }
                          });
                          if (optsName) {
                            this.osArr = this.osg.removeEmpty(item.children, 'children');
                          } else {
                            this.osArr = this.osg.removeEmpty(item.children, 'children');
                          }
                        } else if (codeAuth.doesNotContain && codeAuth.doesNotContain.length > 0) {
                          item.children.map(obj => {
                            if (codeAuth.doesNotContain.indexOf(obj.value) != -1) {
                              obj.disabled = true;
                            }
                          });
                          if (optsName) {
                            this.osArr = this.osg.removeEmpty(item.children, 'children');
                          } else {
                            this.osArr = this.osg.removeEmpty(item.children, 'children');
                          }
                        }
                      } else {
                        if (optsName) {
                          this.osArr = this.osg.removeEmpty(item.children, 'children');
                        } else {
                          that.options[item.type] = this.osg.removeEmpty(item.children, 'children');
                        }
                      }
                    } else {
                      if (optsName) {
                        this.osArr = this.osg.removeEmpty(item.children, 'children');
                      } else {
                        this.osArr = this.osg.removeEmpty(item.children, 'children');
                      }
                    }
                  });
                }
                console.log('this.osArr', this.osArr);
                resolve();
              },
              {
                noload: true
              }
            );
          } else {
            resolve();
          }
        });

        if (callback) callback();
      }
    },
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
        }
      );
    },
    fieldClick(f) {
      this.formData = f;
      this.$forceUpdate();
    },
    fieldCopy(f, index) {
      let field = this.$util.deepCopy(f);
      delete field._id;
      this.fields.splice(index + 1, 0, field);
    },
    fieldDelete(f, index) {
      this.osg.confirm(`是否确认删除${f.nameDisp}？`, () => {
        this.fields.splice(index, 1);
      });
    },
    // 拖拽结束
    end(evt) {
      if (evt.pullMode != 'clone') return; // 拖拽克隆成功才执行操作
      let f = this.fields[evt.newIndex];
      f.name = f.name || f.type + '_' + new Date().getTime(); //默认字段名
      f.preset = f.preset || 1; // 是否预置
      f.required = f.required || '0'; // 校验必填
      f.operationType = f.operationType || '1'; //操作权限
      f.showType = f.showType || '1'; // 查看权限
      f.showList = f.showList || ['1', '2']; // 查看权限
      f.showField = f.showField || ''; //
      f.showValue = f.showValue || '';
      f.showList = f.showList || [];
      f.roleIds = f.roleIds || [];
      f.importSync = f.importSync || 0;
      f.importFlag = f.importFlag || 0;
      f.extId = f.extId || this.ext._id;
      f.colName = f.colName || this.ext.colName;
      f.exts = f.exts || { listEditable: false, replicable: false };
      f.frontEndConfig = f.frontEndConfig || '{}';
      f.calculateConfig = f.calculateConfig || {};
      this.fields[evt.newIndex] = this.$util.deepCopy(f);

      this.$forceUpdate();
      this.fieldClick(this.fields[evt.newIndex]);
    },
    // 获取表单
    getExt() {
      let _id = this.osg.param('extId');
      if (!_id) return;
      this.osg.ajax(
        'biz/ext/query.do',
        {
          _id // xlink: '1'
        },
        res => {
          this.ext = res.data[0];
        },
        {
          noload: true
        }
      );
    },
    getExtFields() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          extId: this.osg.param('extId'),
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order'
        },
        res => {
          res.data.map(item => {
            item.frontEndConfig = item.frontEndConfig || '{}';
            item.calculateConfig = item.calculateConfig ? JSON.parse(item.calculateConfig) : {};
            item.exts.listEditable = item.exts.listEditable || false;
            item.exts.replicable = item.exts.replicable || false;
          });
          this.fields = res.data;
          // 默认选中第一个字段
          if (res.data.length > 0) {
            this.fieldClick(res.data[0]);
          }
        },
        { noload: true }
      );
    },
    //获取字典表类型
    getCodeTypes(query) {
      var params = {
        _all: '1',
        'is:state|integer#and': 1,
        'regex:name|string#or': query,
        'regex:type|string#or': query
      };
      this.osg.ajax('codeType/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item.type;
        });
        this.options.codeType = res.data;
        this.$forceUpdate();
      });
    },
    // 获取脚本
    getScripts(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'is:state|integer#and': 1,
        'is:type|integer#and': '3'
      };
      this.osg.ajax('groovyScript/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.scripts = res.data;
      });
    },
    // 切换是否导入
    importFlagChange(importFlag) {
      if (importFlag == 1) {
        this.$set(this.formData, 'importName', this.formData.nameDisp);
      } else {
        delete this.formData.importRequired;
        delete this.formData.importDistinct;
        delete this.formData.importSync;
        delete this.formData.importName;
        delete this.formData.importType;
      }
      this.$forceUpdate();
    },
    doSave() {
      this.fields.map(item => {
        item.calculateConfig = item.calculateConfig ? JSON.stringify(item.calculateConfig) : '{}';
      });
      this.osg.ajax(
        '/biz/extField/upsertBatch.do',
        {
          datas: JSON.stringify(this.fields)
        },
        () => {
          this.osg.alert('保存成功', () => {
            this.getExtFields();
          });
        }
      );
    },
    /**
     * 关联业务档案配置
     */
    getExts() {
      this.osg.ajax(
        'biz/ext/query.do',
        { _all: '1', 'is:state|integer#and': 1 },
        res => {
          this.options.exts = res.data;
        },
        {
          noload: true
        }
      );
    },
    referenceOpen(formData) {
      this.reference = (formData.exts && formData.exts.reference) || {
        show: true,
        colName: '',
        fields: [],
        options: [],
        params: [],
        pagination: '',
        fec: {},
        setValue: []
      };
      this.reference.show = true;
    },
    referenceColNameClick(ext) {
      this.formData.valueOption = this.reference.colName;
      this.reference.fec.url = ext.exts.queryApi || `biz/extForm/queryByColName/${ext.colName}.do`;
      this.getReferenceFields();
    },
    getReferenceFields() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: this.reference.colName,
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.reference.fields = res.data;
          res.data.map(item => {
            // 整理需要请求的字典
            if (
              item.valueOption &&
              item.type != 'bizSelect' &&
              item.type != 'request' &&
              !item.frontEndConfig.noRequest
            ) {
              if (item.type == 'cascade') {
                this.reference.options['cascadeCode_' + item.name] = {
                  codeId: item.valueOption
                };
              } else {
                this.reference.options['codecfg_' + item.name] = {
                  codeId: item.valueOption
                };
              }
            }
          });
          this.getReferenceOptions();
        },
        {
          noload: true
        }
      );
    },
    async getReferenceOptions(callback) {
      let opts = this.reference.options;
      var cfgArr = [];
      var cascadeTypes = []; //级联的代码类型
      for (var o in opts) {
        if (o.startsWith('codecfg_')) {
          let cfg = opts[o];
          cfg['eleid'] = o.substring(8);
          cfgArr.push(cfg);
          delete opts[o];
        }
        //组合级联代码类型
        if (o.startsWith('cascadeCode_')) {
          let type = o.substring(12);
          cascadeTypes.push(type);
          delete opts[o];
        }
      }
      if (cfgArr.length > 0) {
        await new Promise(resolve => {
          let params = JSON.stringify(cfgArr);
          this.osg.ajax(
            'i/code/selectCode.do',
            {
              jsonPara: params
            },
            res => {
              if (res) {
                res = JSON.parse(res);
                for (var i = 0; i < res.length; i++) {
                  var opts = res[i],
                    os = opts.options;
                  var osArr = [];
                  for (let opt in os) {
                    osArr.push({
                      label: os[opt],
                      value: opt
                    });
                  }
                  this.reference.options[opts.eleid] = osArr;
                }
                resolve();
              }
            },
            {
              noload: true
            }
          );
        });
      }
      if (cascadeTypes.length > 0) {
        await new Promise(resolve => {
          this.osg.ajax(
            'i/code/selectMultistageCode.do',
            {
              types: cascadeTypes.join()
            },
            res => {
              if (res.constructor == Array) {
                res.map(item => {
                  this.reference.options[item.type] = this.osg.removeEmpty(
                    item.children,
                    'children'
                  );
                });
              }
              resolve();
            },
            {
              noload: true
            }
          );
        });
      }
      if (callback) callback();
    },
    setReference(type) {
      let that = this;
      let reference = this.reference;
      let params = {};
      for (let row of reference.params) {
        if (
          !row.fieldName ||
          !row.condition ||
          !row.valueType ||
          (row.condition != 'doesNotExists' &&
            row.condition != 'exists' &&
            (row.valueType == 3 ? row.values.length == 0 : !row.value)) ||
          !row.relation
        ) {
          that.osg.toast('请选择过滤条件', 'warning');
          return;
        }
        let condition;
        switch (row.condition) {
          case 'contains': //包含
            if (row.valueType == '1' || row.valueType == '2') {
              condition = 'regex';
            } else if (row.targetField.multiple) {
              condition = 'all';
            } else {
              condition = 'in';
            }
            break;
          case 'doesNotContain': //不包含
            condition = 'nin';
            break;
          case '=': //等于
            if (row.valueType == '3' && row.values.length > 1) {
              condition = 'in';
            } else {
              condition = 'eq';
            }
            break;
          case '!=': //不等于
            condition = 'ne';
            break;
          case '<=': //小于等于
            condition = 'lte';
            break;
          case '>=': //大于等于
            condition = 'gte';
            break;
          case 'doesNotExists': //为空
            condition = 'exists';
            break;
          case 'exists': //不为空
            condition = 'exists';
            break;
          default:
            return;
        }

        let fieldName;
        if (row.targetField.preset) {
          fieldName = row.fieldName;
        } else {
          fieldName = 'exts.' + row.fieldName;
        }

        let type =
          row.targetField.frontEndConfig.number ||
          row.targetField.frontEndConfig.string ||
          row.targetField.type;
        if (condition == 'exists') {
          type = 'boolean';
        } else if (type == 'number' || type == 'integer') {
          if (row.targetField.multiple) {
            type = 'array-integer';
          } else {
            type = 'integer';
          }
        } else if (type == 'dateTime') {
          type = 'datetime';
        } else if (type == 'date') {
          type = 'date';
        } else {
          type = 'string';
        }

        let value;
        // 1:固定值 2:模糊搜索值 3:查询表单字段选项 4:当前表单字段值
        if (condition == 'exists') {
          if (row.condition == 'doesNotExists') {
            value = true;
          } else {
            value = false;
          }
        } else if (row.valueType == '3') {
          value = row.values.join();
        } else if (row.valueType == '4') {
          if (row.field.preset) {
            value = '$' + row.value;
          } else {
            value = '$exts.' + row.value;
          }
        } else {
          value = row.value;
        }

        let param = `${condition}:${fieldName}|${type}#${row.relation}`;
        params[param] = value;
      }
      reference.fec.params = params;
      console.log('params', params);

      let setValue = {};
      for (let row of reference.setValue) {
        if (!row.key || !row.value) {
          that.osg.toast('请选择赋值规则', 'warning');
          return;
        }
        let key, value;
        if (row.field.preset) {
          key = row.key;
        } else {
          key = 'exts.' + row.key;
        }
        if (row.targetField.preset) {
          value = '$' + row.value;
        } else {
          value = '$exts.' + row.value;
        }
        setValue[key] = value;
      }
      reference.fec.setValue = setValue;
      console.log('setValue', setValue);
      if (type == 'preview') {
        this.$forceUpdate();
        return;
      }
      this.formData.frontEndConfig = JSON.stringify(
        Object.assign(JSON.parse(this.formData.frontEndConfig), reference.fec)
      );
      reference.show = false;
      this.formData.exts = this.formData.exts || {};
      this.formData.exts.reference = reference;
    },
    //初始化地图
    initMap() {
      this.record.openMap = true;
      window._AMapSecurityConfig = {
        securityJsCode: '3788aba03fd31c6043d09d13ef61a9fd'
      };
      AMapLoader.load({
        key: '1a9bad1cbe81dd0c59194c657566254b', //此处填入我们注册账号后获取的Key
        version: '2.0', //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [''] //需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(async AMap => {
          new AMap.Map('container', {
            //设置地图容器id
            viewMode: '2D', //是否为3D地图模式
            zoom: 9, //初始化地图级别
            center: [116.397428, 39.90923], //初始化地图中心点位置
            zooms: [8, 18]
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style scoped lang="scss">
#app .fd {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .fd-header {
    position: relative;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    box-shadow: 0 2px 4px rgb(0 0 0 / 15%);
  }
  .fd-content {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    .fd-left,
    .fd-right {
      width: 300px;
      min-width: 300px;
      box-sizing: border-box;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .fd-type {
        width: 270px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .fd-type-item {
          width: 120px;
          margin-top: 10px;
          padding: 5px;
          box-sizing: border-box;
          border: 1px solid transparent;
          border-radius: 5px;
          cursor: pointer;
          &:hover {
            border-color: #409eff;
          }
          display: flex;
          align-items: center;
          .i-icon {
            margin-right: 5px;
            display: flex;
          }
        }
      }
    }
    .fd-center {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 15px;
      min-width: 400px;
      overflow-y: auto;
      background-color: #f5f8fa;
      .fd-center-icons {
        display: flex;
        align-items: center;
        .i-icon {
          display: inline-flex;
          cursor: pointer;
          padding: 5px;
          border-radius: 50%;
        }
        .i-icon.active {
          background-color: #fff;
        }
      }
      .fd-center-detail {
        flex: 1;
        border-radius: 10px;
        margin: 15px;
        padding: 12px;
        background: #fff;
        overflow: hidden;
        > .el-form {
          margin: 0 auto;
          width: 100%;
          height: 100%;
          overflow: hidden;
          box-sizing: border-box;
          > div {
            height: 100%;
            overflow-y: auto;
            .fd-form-item {
              cursor: move;
              padding: 12px;
              border-radius: 8px;
              position: relative;
              &:hover {
                background-color: #fafafb;

                .fd-form-item-icons {
                  display: flex;
                }
              }
              .fd-form-item-icons {
                display: none;
                color: #999;
                position: absolute;
                top: -5px;
                right: 12px;
                border-radius: 24px;
                overflow: hidden;
                box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%);
                .i-icon {
                  background-color: #fff;
                  padding: 5px 6px;
                  cursor: pointer;
                }
                .i-icon.copy {
                  border-radius: 50% 0 0 50%;
                  &:hover {
                    color: #409eff !important;
                    background-color: #e9f3fe;
                  }
                }
                .i-icon.delete {
                  border-radius: 0 50% 50% 0;
                  &:hover {
                    color: #f56c6c !important;
                    background-color: #fdecec;
                  }
                }
              }
              .el-form-item {
                margin-bottom: 0;
              }
              .el-form-item.type-title,
              .el-form-item.type-gap,
              .el-form-item.type-displayText {
                ::v-deep .el-form-item__label {
                  padding-bottom: 0;
                }
              }
              .el-form-item.type-gap {
                ::v-deep .el-form-item__label {
                  width: 100%;
                  > div {
                    span:last-child {
                      width: 100%;
                      height: 32px;
                      background: #f2f2f2;
                    }
                  }
                }
              }
              ::v-deep .el-input__inner,
              ::v-deep .el-textarea__inner {
                cursor: move;
                background: #fff;
              }
              ::v-deep .el-radio-group {
                display: flex;
                flex-wrap: wrap;
                // .el-radio {
                //   cursor: move;
                // }
                // .el-radio__input {
                //   cursor: move !important;
                //   .el-radio__inner {
                //     cursor: move !important;
                //     &:hover {
                //       border-color: #dcdfe6;
                //     }
                //   }
                // }
              }
            }
            .fd-form-item.active {
              background-color: #eff3fd;
            }
          }
        }
        > .el-form.mobile {
          border: 1px solid #d9d9d9;
          border-radius: 10px;
        }
      }
      .fd-center-detail.mobile {
        width: 375px;
        margin: 15px auto;
      }
    }

    .fd-right {
      display: flex;
      flex-direction: column;
      > .el-form {
        flex: 1;
        overflow-y: auto;
        ::v-deep .el-form-item__label {
          font-weight: 500;
          padding: 0;
          display: flex;
        }
        .el-form-item__content {
          > div {
            flex-wrap: wrap;
          }
        }
      }
    }
  }
  .bizSelect-dialog {
    ::v-deep .el-dialog {
      width: 1200px;
    }
    ::v-deep .el-form-item__content {
      display: flex;
      > div {
        width: auto !important;
        height: 32px;
        display: flex !important;
        align-items: center;
      }
    }
    .pagination-input {
      width: 50px;
      ::v-deep .el-input__inner {
        padding: 0 5px;
        text-align: center;
      }
    }
  }
}
.c-uploader {
  .el-upload {
    border-radius: 3px !important;
    img {
      width: 90px;
      height: 90px;
      display: block;
    }
  }
}

// 添加弹窗专用样式
.form-designer-dialog {
  .fd-content {
    height: calc(100vh - 200px);
    overflow: auto;
  }

  .fd-left,
  .fd-right {
    height: 100%;
  }
}

.ant-popover {
  display: none;
}
</style>
